import styles from "./AgentEinsteinButton.module.css";
import AgentIcon from "@lib/experiment/agent/AgentIcon";
import { ActionIcon, Tooltip } from "@mantine/core";

export default function AgentEinsteinButton({ hide, onClick }: { hide?: boolean; onClick: VoidFunction }) {
  return (
    <Tooltip label="AI chat assistance for your experiment" disabled={hide}>
      <ActionIcon
        classNames={{ root: styles.root }}
        radius="100%"
        p="xs"
        c="var(--mantine-color-bright)"
        size="2.1rem"
        onClick={onClick}
        data-hide={hide ? true : undefined}
        style={{ boxShadow: "var(--mantine-shadow-lg)" }}
      >
        <AgentIcon size="1.6rem" />
      </ActionIcon>
    </Tooltip>
  );
}
